const primaryMain = '#0B2136';
const primaryMainOpacity = 'rgba(11, 33, 54, 0.9)';
const secondaryMain = '#00B5A2';
const secondaryMainOpacity = 'rgba(0, 181, 162, 0.5)';
const secondaryLight = '#E2F4F0';
const tertiaryMain = '#43535E';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
